module.exports = __webpack_public_path__ + "static/img/AlertLight.3de1835b.png";